import GeneralModal from '@/components/new/common/modal/GeneralModal.vue'
const Modal = {}
Modal.install = function (Vue) {
  const ModalConstructor = Vue.extend(GeneralModal)
  const instance = new ModalConstructor()
  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  Vue.prototype.$alert = (title, tip, content) => {
    instance.type = 'alert'
    instance.title = title
    instance.tip = tip
    instance.content = content
    instance.isShow = true
  }
  Vue.prototype.$confirm = (title, tip, content, success, cancel, close) => {
    instance.type = 'confirm'
    instance.title = title
    instance.tip = tip
    instance.content = content
    instance.isShow = true
    if (typeof success !== 'undefined') {
      instance.success = success
    }
    if (typeof cancel !== 'undefined') {
      instance.cancel = cancel
    }
    if (typeof close !== 'undefined') {
      instance.close = close
    }
  }
}

export default Modal
